const intervalsTimeAgo = [
  {singular: 'rok', plural: 'lata', seconds: 31536000},
  {singular: 'miesiąc', plural: 'miesiące', seconds: 2592000},
  {singular: 'dzień', plural: 'dni', seconds: 86400},
  {singular: 'godzina', plural: 'godziny', seconds: 3600},
  {singular: 'minuta', plural: 'minuty', seconds: 60},
  {singular: 'sekund', plural: 'sekundy', seconds: 0}
]

function addLeadingZero (text) {
  return ('0' + text).slice(-2)
}

export function formatDateTime (date) {
  return [addLeadingZero(date.getDate()), addLeadingZero(date.getMonth() + 1), date.getFullYear()].join('.')
}

export function formatTimeAgo (date) {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  if (seconds < 60) {
    return `chwilę temu`
  }

  const interval = intervalsTimeAgo.filter(i => i.seconds < seconds)[0]
  const count = Math.floor(seconds / interval.seconds)
  return `${count} ${interval[count !== 1 ? 'plural' : 'singular']} temu`
}



// WEBPACK FOOTER //
// ./src/shared/datetime.js